import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import {
  BULK_UPLOAD,
  CATEGORY,
  EXCEL_EXPORT_ALL_DATA_SUPERVISOR,
  GET_ALL_LEADS,
  GET_ESTIMATIONS_SV,
  GET_MEETING_SV,
  GET_ON_CALL_DISCUSSION,
  GET_ON_CALL_DISCUSSION_SV,
  GET_SITE_VISIT_SV,
  GET_TIMELINE,
} from "../../constants";
import "./siteVisitpageStyles.css";
import {
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  LinearProgress,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Stack, Snackbar } from "@mui/material";
import ModalComponent from "../reusable Component/modalComponent";
import * as XLSX from "xlsx";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import LongTextComponent from "../Leads Page/LongTextComponent";
import Loader from "../reusable Component/Loader";
import { useTheme } from "@emotion/react";
import moment from "moment";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { saveAs } from "file-saver";
import UploadIcon from "@mui/icons-material/Upload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TimelineDialog from "../reusable Component/TimelineDialog";

function MasterDataComponent() {
  const [row, setRow] = useState([]);
  const fileInputRef = useRef();
  const navigate = useNavigate();
  const [inputKey, setInputKey] = useState(Date.now());

  const [loading, setLoading] = useState(false);

  const dt = useRef(null);

  const [currentPage, setCurrentPage] = useState(0); // Zero-based index
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10); // Rows per page
  const [pageCount, setPageCount] = useState(0);

  const [runEffect, setRunEffect] = useState(false);

  useEffect(() => {
    fetchLeads(currentPage, pageSize);
    console.log("effect running", currentPage);
  }, [currentPage, pageSize]);

  const fetchLeads = async (page, size) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${GET_ALL_LEADS}?page=${page + 1}&limit=${size}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const { leads, totalLeads, totalPages } = response.data;
      handlingRowData(leads);
      setTotalRecords(totalLeads);
      setPageCount(totalPages);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLoading(false);
    }
  };

  const handlingRowData = (rowData) => {
    const transformedRows = rowData.map((rd, index) => ({
      id: index + 1,
      SNo: index + 1,
      leadId: rd.id,
      CustomerName: rd.CustomerName || "-",
      MobileNo: rd.MobileNo || "-",
      AlternateMobileNo: rd.AlternateMobileNo || "-",
      state_name: rd.state_name || "-",
      source_of_lead_generated: rd.Campaign?.CampaignName || "-",
      category: rd.category || "-",
      AgentId: rd.AgentId,
      BDMId: rd.BDMId,
      CustomerMailId: rd.CustomerMailId || "-",
      InquiryType: rd.InquiryType || "-",
      Project: rd.Project,
      Superviser: rd.Superviser,
      SuperviserID: rd.SuperviserID,
      WhatsappNo: rd.WhatsappNo || "-",
      agent_remark: rd.agent_remark || "-",
      close_month: rd.close_month || "-",
      follow_up_date: rd.follow_up_date ? formatDate(rd.follow_up_date) : "-",
      lead_owner: rd.BDM?.EmployeeName || "-",
      lead_transfer_date: rd.lead_transfer_date
        ? formatDate(rd.lead_transfer_date)
        : "-",
      location: rd.location || "-",
      site_location_address: rd.site_location_address || "-",
      region_name: rd.region_name || "-",
      sub_category: rd.sub_category || "-",
      Agent: rd.Agent,
      AgentName:
        rd.Campaign?.CampaignName === "BDM_Lead"
          ? rd.BDM?.EmployeeName || "-"
          : rd.Agent?.EmployeeName || "-",
      BDM: rd.BDM,
      pincode: rd.pincode || "-",
      call_status: rd.call_status || "-",
      call_type: rd.call_type || "-",
      createdDate: rd.createdAt ? formatDate(rd.createdAt) : "-",
      bdm_remark: rd.bdm_remark || "-",
      lead_calling_date: "-", // Placeholder
      bdm_calling_date: "-", // Placeholder
      updatedAt: rd.updatedAt ? formatDate(rd.updatedAt) : "-",
      last_action: rd.last_action || "-",
    }));
    setRow(transformedRows);
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const [open, setOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [viewMode, setViewMode] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setViewMode(false);
    setModalTitle("Lead Generation");
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const [openUpload, setOpenUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setOpenUpload(true);
      setFile(file);
    }
  };

  const handleUpload = () => {
    setUploading(true);
    setProgress(0);

    // Start the actual file upload immediately
    uploadFile(file);

    // Simulate progress for the dialog
    const uploadInterval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(uploadInterval);
          return 100; // Ensure it reaches 100
        }
        return prevProgress + 10; // Simulate progress increase
      });
    }, 500);
  };

  const uploadFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(BULK_UPLOAD, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        console.log("File uploaded successfully:", response.data);
        setSeverity("success");
        setMessage(response.data.message);
        setOpenSnackbar(true);

        setUploading(false);
        setOpenUpload(false);

        fileInputRef.current.value = null;
        setRunEffect(true);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setOpenUpload(false);
        setFile(null);
        setSeverity("error");
        setMessage(error.response.data.message);
        setOpenSnackbar(true);
      });
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleCloseDialog = () => {
    if (!uploading) {
      setOpenUpload(false);
      setFile(null);
    }
  };

  const theme = useTheme();
  const isXs = useMediaQuery("(max-width:600px)"); // 0px - 600px
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600px - 900px
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg")); // 900px - 1200px
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl")); // 1200px - 1536px
  const isXl = useMediaQuery(theme.breakpoints.up("xl")); // 1536px and up

  const getHeight = () => {
    if (isXs) return 400;
    if (isSm) return 400;
    if (isMd) return 450;
    if (isLg) return 600;
    if (isXl) return "100vh";
    return "auto";
  };

  const columns = useMemo(
    () => [
      //   {
      //     accessorKey: "SNo", //simple recommended way to define a column
      //     header: "S No",
      //     // muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
      //     // Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong> //optional custom cell render
      //   },
      {
        id: "SNo", // Unique ID for the column
        header: "SNo",
        size: 50,
        // Create a dynamic serial number based on row index
        Cell: ({ row, table }) => {
          // Calculate SNo based on current pageIndex and pageSize
          const { pageIndex, pageSize } = table.getState().pagination;
          return pageIndex * pageSize + row.index + 1;
        },
        enableSorting: false, // Disable sorting
        enableColumnFilter: false, // Disable filtering
        enableHiding: false, // Disable hiding
      },
      {
        // accessorFn: (row) => row.age, //alternate way
        // id: "age", //id required if you use accessorFn instead of accessorKey
        accessorKey: "last_action",
        header: "Last Action",
        size: 150,
        // Header: <i style={{ color: "red" }}>Age</i> //optional custom markup
      },
      {
        // accessorFn: (row) => row.age, //alternate way
        // id: "age", //id required if you use accessorFn instead of accessorKey
        accessorKey: "lead_owner",
        header: "Lead Owner",
        size: 150,
        // Header: <i style={{ color: "red" }}>Age</i> //optional custom markup
      },
      {
        accessorKey: "CustomerName",
        header: "Customer Name",
        size: 200,
      },
      {
        accessorKey: "MobileNo",
        header: "Mobile Number",
        size: 150,
      },
      {
        accessorKey: "region_name",
        header: "Region Name",
        size: 180,
      },
      {
        accessorKey: "category",
        header: "Category",
        size: 150,
        filterFn: "equals",
        Cell: ({ cell }) => (
          <Chip
            size="small"
            color={getColorForTag(cell.getValue())}
            label={cell.getValue()}
            sx={{ textTransform: "capitalize", height: "20px" }}
          />
        ),
      },
      {
        accessorKey: "sub_category",
        header: "Sub-Category",
        size: 150,
      },
      {
        accessorKey: "agent_remark",
        header: "CSE Remark",
        size: 250,
        enableColumnFilter: false,
        Cell: ({ cell }) => (
          <LongTextComponent text={cell.getValue() || ""} maxLength={50} />
        ),
      },
      {
        accessorKey: "bdm_remark",
        header: "BDM Remark",
        filterFn: "contains", // Use a string filter
        size: 250,
        enableColumnFilter: false,
        Cell: ({ cell }) => (
          <LongTextComponent text={cell.getValue() || ""} maxLength={50} />
        ),
      },
      {
        accessorKey: "InquiryType",
        header: "Enquiry Type",
        size: 200,
      },
      {
        accessorKey: "call_status",
        header: "Call Status",
        size: 200,
      },
      {
        accessorKey: "call_type",
        header: "Call Type",
        size: 200,
      },
      {
        accessorKey: "location",
        header: "Location",
        size: 200,
      },
      {
        accessorKey: "state_name",
        header: "State",
        size: 150,
      },
      {
        accessorKey: "CustomerMailId",
        header: "Customer Mail ID",
        size: 200,
      },
      {
        accessorKey: "createdDate",
        header: "Date of First Calling",
        size: 250,
      },
      {
        accessorKey: "follow_up_date",
        header: "Follow-Up Date",
        size: 180,
      },
      {
        accessorKey: "close_month",
        header: "Closure Month",
        size: 180,
      },
      {
        accessorKey: "lead_transfer_date",
        header: "Date of Lead Transfer",
        size: 250,
      },
      {
        accessorKey: "bdm_calling_date",
        header: "Date of BDM Calling",
        size: 180,
      },
      {
        accessorKey: "source_of_lead_generated",
        header: "Campaign Name",
        size: 200,
      },
      {
        accessorKey: "AgentName",
        header: "CSE Name",
        size: 150,
      },
      {
        accessorKey: "Project",
        header: "Project",
        size: 200,
      },
      {
        accessorKey: "AlternateMobileNo",
        header: "Alt Mobile Number",
        size: 150,
      },
      {
        accessorKey: "WhatsappNo",
        header: "Whatsapp Number",
        size: 150,
      },
      {
        accessorKey: "updatedAt",
        header: "Lead Updated On",
        size: 180,
      },
      {
        accessorKey: "action",
        header: "Action",
        size: 50,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Tooltip title="Timeline" arrow>
            <IconButton
              style={{
                border: "1px solid",
                borderRadius: "4px",
                padding: "2px",
                width: "24px",
                height: "24px",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "5px",
              }}
              color="primary"
              onClick={() => {
                // console.log(row.original); // This will log the entire row data
                handletimelineClick(row.original);
              }}
            >
              <VisibilityIcon fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
        ),

        muiTableBodyCellProps: {
          sx: {
            position: "sticky",
            right: 0, // Stick to the right
            zIndex: 10, // Ensure it has a higher z-index than other columns
            backgroundColor: "white", // Consistent background
            borderLeft: "1px solid rgba(224, 224, 224, 1)", // Add border if needed
            textAlign: "center",
          },
        },
        muiTableHeadCellProps: {
          sx: {
            position: "sticky",
            right: 0, // Make the header stick as well
            zIndex: 11, // Ensure it stays on top of body cells
            backgroundColor: "#EEF0F4", // Match table header background
          },
        },
      },
    ],
    []
  );

  const [openTimeline, setopenTimeline] = useState(false);
  const [timelineLogs, setTimelineLogs] = useState([]);
  const [custData, setCustData] = useState([]);

  const handletimelineClick = (row) => {
    setopenTimeline(true);
    setCustData(row);
    axios
      .get(`${GET_TIMELINE}/${row.leadId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { leadLogs } = response.data;
        setTimelineLogs(leadLogs);
      })
      .catch((error) => {});
  };

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "hot":
        return "error"; // React blue
      case "warm":
        return "warning"; // JavaScript yellow
      case "cold":
        return "info"; // UI dark blue
      default:
        return "default"; // Default gray
    }
  };

  const handleExportData = () => {
    const flattenedData = flattenData(row);
    const csv = generateCsv(csvConfig)(flattenedData);
    download(csvConfig)(csv);
    handleMenuClose();
  };

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
  });

  const flattenData = (data) => {
    return data.map((item) => {
      return {
        ...item,
        Updates: item.estimations ? JSON.stringify(item.Updates) : "", // Flatten the `estimations` array
        Agent: item.Agent ? JSON.stringify(item.Agent) : "", // Flatten the `Agent` object
        BDM: item.BDM ? JSON.stringify(item.BDM) : "", // Flatten the `BDM` object
      };
    });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleCloseModal = () => {
    setIsDownloading(false);
  };

  const handleExport = () => {
    setIsDownloading(true); // Open progress modal
    setDownloadProgress(0); // Reset progress

    handleMenuClose();

    let artificialProgressInterval;

    // Start artificial progress if the real progress is too fast
    artificialProgressInterval = setInterval(() => {
      setDownloadProgress((prevProgress) => {
        // Stop artificial progress at 90%
        if (prevProgress >= 70) {
          clearInterval(artificialProgressInterval);
          return prevProgress;
        }
        return prevProgress + 10; // Increment by 10 every 100ms
      });
    }, 100); // Update every 100ms

    axios
      .get(EXCEL_EXPORT_ALL_DATA_SUPERVISOR, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        timeout: 60000, // 1-minute timeout
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            const realProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            // Stop artificial progress when real progress updates
            clearInterval(artificialProgressInterval);

            // Update progress based on real data, but ensure it doesn't go backwards
            setDownloadProgress((prevProgress) =>
              Math.max(prevProgress, realProgress)
            );
          } else {
            console.warn("Unable to calculate download progress");
          }
        },
      })
      .then((response) => {
        clearInterval(artificialProgressInterval); // Ensure artificial progress is cleared

        // Create file download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "all-lead-file.xlsx";
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename="(.+)"/);
          if (matches && matches.length > 1) {
            fileName = matches[1];
          }
        }
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Close modal and show success
        setIsDownloading(false);
        setDownloadProgress(0);
        // setSeverity('success');
        // setMessage('File downloaded successfully');
        // setOpenSnackbar(true);
      })
      .catch((error) => {
        clearInterval(artificialProgressInterval);
        console.error("Error downloading file:", error);
        setIsDownloading(false);
        setDownloadProgress(0);
        setSeverity("error");
        setMessage("Failed to download the file");
        setOpenSnackbar(true);
      });
  };

  const handlePaginationChange = (updater) => {
    const newState =
      typeof updater === "function"
        ? updater(table.getState().pagination)
        : updater;

    console.log(newState); // For debugging

    const maxPageIndex = Math.max(0, pageCount - 1);
    const newPageIndex = Math.max(
      0,
      Math.min(newState.pageIndex, maxPageIndex)
    );

    // Update current page only if it has changed
    if (newPageIndex !== currentPage) {
      setCurrentPage(newPageIndex); // Update current page state
      fetchLeads(newPageIndex, pageSize); // Fetch new data based on the new page
    }

    // Update page size only if it has changed
    if (newState.pageSize !== pageSize) {
      setPageSize(newState.pageSize);
      fetchLeads(newPageIndex, newState.pageSize); // Fetch new data with updated page size
    }
  };

  const table = useMaterialReactTable({
    data: row,
    columns,
    state: {
      pagination: {
        pageIndex: currentPage,
        pageSize: pageSize,
      },
    },
    autoResetPage: false,
    autoResetPageIndex: false,
    manualPagination: true,
    pageCount: pageCount,
    onPaginationChange: handlePaginationChange,
    enableStickyHeader: true,
    defaultColumn: {
      minSize: 100,
      maxSize: 300,
      size: 150,
    },
    getRowId: (row) => row.id,
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#EEF0F4",
        boxSizing: "border-box",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        boxSizing: "border-box",
      },
    },
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <Tooltip title="Export Options">
          <Button
            variant="text"
            onClick={handleMenuClick}
            startIcon={<FileDownloadIcon />}
          >
            Export
          </Button>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleExport}>Export to Excel</MenuItem>
          {/* <MenuItem onClick={handleExportData}>Export to CSV</MenuItem> */}
        </Menu>
        <Button
          variant="text"
          color="primary"
          startIcon={<UploadIcon />}
          onClick={handleButtonClick}
          sx={{
            float: "right",
            marginRight: "16px",
            fontSize: "14px",
          }}
        >
          Bulk Upload
        </Button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".xlsx, .xls"
          onChange={handleFileChange}
        />
      </Box>
    ),
  });

  return (
    <>
      {loading && <Loader open={loading} />}
      <MaterialReactTable table={table} />

      <ModalComponent
        open={open}
        modalTitle={modalTitle}
        setOpenSnackbar={setOpenSnackbar}
        setOpen={setOpen}
        setSeverity={setSeverity}
        setMessage={setMessage}
        viewMode={viewMode}
      ></ModalComponent>

      <Dialog
        open={isDownloading}
        onClose={(event, reason) => {
          // Disable closing when clicking outside the modal or pressing 'Escape'
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseModal();
          }
        }}
      >
        <DialogTitle>File Download in Progress...</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "250px",
              minHeight: "150px",
            }}
          >
            {/* Circular Progress with larger size */}
            <CircularProgress
              variant="determinate"
              value={downloadProgress}
              size={80}
              thickness={4}
              sx={{ color: downloadProgress < 100 ? "#1976d2" : "#4caf50" }} // Progress color change
            />
            <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
              {downloadProgress}%
            </Typography>
            {/* Optional text for completed state */}
            {downloadProgress === 100 && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                Download complete! Preparing your file...
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      <Dialog
        open={openUpload}
        onClose={handleCloseDialog}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle>{"Confirm Upload"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {uploading
              ? "Uploading..."
              : "Are you sure you want to upload the selected file?"}
          </DialogContentText>
          {uploading && (
            <Box sx={{ width: "100%", mt: 2, height: "30px" }}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {!uploading && (
            <>
              <Button onClick={handleCloseDialog} color="primary">
                Cancel
              </Button>
              <Button onClick={handleUpload} color="primary" autoFocus>
                Confirm
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      <TimelineDialog
        open={openTimeline}
        setOpen={setopenTimeline}
        timelineLogs={timelineLogs}
        custData={custData}
      ></TimelineDialog>
    </>
  );
}

export default MasterDataComponent;
